import fetch from "isomorphic-fetch";
import { API2_URL, AGENCIES_FAIL, AGENCIES_SHOW, AGENCIES_EDIT, /*AGENCIES_FETCH,*/ AGENCIES_REQUEST, AGENCIES_COMPLETE,
		AGENCIES_MUNICIPALITIES_REQUEST, AGENCIES_MUNICIPALITIES_FETCH} from "../store/config";
import {sessionService} from "redux-react-session";
import {newNotification} from "./notifications";
import _ from 'lodash';
import {entitiesList} from "./entities";
import {versionsList} from "./versions";
import {municipalityEdit} from "./municipalities";
//import {fetchUserAgencies} from "./login";
import {history} from "../store/store";

export const agenciesShow = (page = 1,filters={}) => (dispatch) => {
	dispatch(agenciesRequest());
	return dispatch(sessionService.loadUser)
		.then(sess => {
			const options = {headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json',
					'Authorization': `Bearer ${sess.profile.access_token}`
				},
				method: 'get'
			};

			let params = '';
			_.mapKeys(filters, (value, key) => {
				if(value){
					params = `${params}&${key}=${value}`;
				}
			});

			return fetch(`${API2_URL}/agencies?page=${page}${params}`, options)
				.then(result => {
					if (result.status >= 200 && result.status < 300) {
						return result.json();
					} else {
						return result.json().then(Promise.reject.bind(Promise));
					}
				})
				.then(
					json => dispatch(agenciesData(json)),
					error => {
						dispatch(newNotification({title:"¡Oh no!", content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error), type: "danger"}));
						return dispatch(agenciesFailed(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)));
					}
				);
		})
}

export const agencyEdit = (id = undefined) => (dispatch) => {
	dispatch(agenciesRequest());
	dispatch(entitiesList())
	return dispatch(versionsList())
		.then((versions) => {
			if(!_.isEmpty(versions.payload)){
				if(id){
					return dispatch(fetchAgencyEdit(id))
				}else {
					return dispatch(agenciesComplete())
				}
			}else {
				return dispatch(agenciesFailed('Carga de instancia incompleta'));
			}
		})
}

export const fetchAgencyEdit = (id) => (dispatch) => {
	return dispatch(sessionService.loadUser)
		.then(sess => {
			const options = {headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json',
					'Authorization': `Bearer ${sess.profile.access_token}`
				},
				method: 'get'
			};

			return fetch(`${API2_URL}/agencies/${id}`, options)
				.then(result => {
					if (result.status >= 200 && result.status < 300) {
						return result.json();
					} else {
						return result.json().then(Promise.reject.bind(Promise));
					}
				})
				.then(
					json =>{
						if(json.data.agenciable_type === 'imm'){
							return dispatch(municipalityEdit(json.data.agenciable_id))
								.then(municipality => {
									if(!_.isEmpty(municipality.payload)){
										//console.log('foundAgenciable===>');
										let agenciable_state_id = municipality.payload.state_id;
										return dispatch(fetchAgencyMunicipalities(municipality.payload.state_id))
											.then(municipalities => {
												if(!_.isEmpty(municipalities.payload)){
													return dispatch(agenciesEditData({...json,data:{...json.data,agenciable_state_id: agenciable_state_id} }))
												}else {
													return dispatch(agenciesFailed('Carga de instancia incompleta'));
												}
											})
									}else {
										return dispatch(agenciesFailed('Carga de instancia incompleta'));
									}
								})
						}else {
							return dispatch(agenciesEditData(json))
						}
					},
					error => {
						dispatch(newNotification({title:"¡Oh no!", content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error), type: "danger"}));
						return dispatch(agenciesFailed(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)));
					}
				);
		})
}

export const agencyEditSave = (values) => (dispatch) => {
	return dispatch(sessionService.loadUser)
		.then(sess => {
			dispatch(agenciesRequest());

			let body = {
				...values,
				agenciable_id: values.agenciable_type === 'imef' ? values.agenciable_state_id:values.agenciable_municipality_id
			}
			const options = {headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json',
					'Authorization': `Bearer ${sess.profile.access_token}`
				},
				method: 'post',
				body: JSON.stringify(body)
			};

			return fetch(`${API2_URL}/agencies${values.id ? `/${values.id}?_method=PUT`:''}`, options)
				.then(result => {
					if (result.status >= 200 && result.status < 300) {
						return result.json();
					} else {
						return result.json().then(Promise.reject.bind(Promise));
					}
				})
				.then(
					json => {
						//console.log('values===>', values);
						//console.log('validate===>', _.isEmpty(values.id));
						dispatch(newNotification({title: "Éxito", content: json.message ? json.message: "La instancia se ha guardado correctamente", type: "success"}));
						if(!_.isNumber(values.id)){
							//dispatch(fetchUserAgencies(sess.profile.access_token));
							history.push(`/instancias/editar/${json.data.id}`);
						}else {
							//console.log('into else===>');
							if(json.data.agenciable_type === 'imm'){
								return dispatch(municipalityEdit(json.data.agenciable_id))
									.then(municipality => {
										if(!_.isEmpty(municipality.payload)){
											//console.log('foundAgenciable===>');
											let agenciable_state_id = municipality.payload.state_id;
											return dispatch(fetchAgencyMunicipalities(municipality.payload.state_id))
												.then(municipalities => {
													if(!_.isEmpty(municipalities.payload)){
														return dispatch(agenciesEditData({...json,data:{...json.data,agenciable_state_id: agenciable_state_id} }))
													}else {
														return dispatch(agenciesFailed('Carga de instancia incompleta'));
													}
												})
										}else {
											return dispatch(agenciesFailed('Carga de instancia incompleta'));
										}
									})
							}else {
								//console.log('advance here===>');
								return dispatch(agenciesEditData(json))
							}
						}
					},
					error => {
						dispatch(newNotification({title:"¡Oh no!", content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error), type: "danger"}));
						return dispatch(agenciesFailed(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)));
					}
				);
		})
}

export const agencyDelete = (id) => (dispatch) => {
	dispatch(agenciesRequest());
	return dispatch(sessionService.loadUser)
		.then(sess => {
			const options = {headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json',
					'Authorization': `Bearer ${sess.profile.access_token}`
				},
				method: 'delete'
			};

			return fetch(`${API2_URL}/agencies/${id}`, options)
				.then(result => {
					if (result.status >= 200 && result.status < 300) {
						return result.json();
					} else {
						return result.json().then(Promise.reject.bind(Promise));
					}
				})
				.then(
					json => {
						dispatch(newNotification({title: "Éxito", content: json.message ? json.message:"La instancia se ha borrado exitosamente", type: "success"}));
						dispatch(agenciesShow());
						return dispatch(agenciesComplete());
					},
					error => {
						dispatch(newNotification({title:"¡Oh no!", content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error), type: "danger"}));
						return dispatch(agenciesFailed(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)));
					}
				);
		})
}

const agenciesData = (json) => {
	return {
		type: AGENCIES_SHOW,
		isFetching: false,
		payload: json.data,
		pages: {
			current: json.current_page,
			per_page: json.per_page,
			total: json.total
		},
		permissions: json.permissions,
		timestamp: Date.now()
	}
}

const agenciesEditData = (json) => {
	let response = {};

	_.mapKeys(json.data,(item, key) => {
		response = {
			...response,
			[key]:item ? item:undefined
		}
	})

	if(json.data.agenciable_type === 'imm'){
		response = {
			...response,
			agenciable_municipality_id: json.data.agenciable_id
		}
	}else {
		response = {
			...response,
			agenciable_state_id: json.data.agenciable_id
		}
	}

	response = {
		...response,
		state_id: !_.isEmpty(json.data.municipality) ? json.data.municipality.state_id:undefined
	}


	return {
		type: AGENCIES_EDIT,
		isFetching: false,
		payload: response,
		permissions: json.permissions,
		timestamp: Date.now()
	}
}

const agenciesRequest = () => {
	return {
		type: AGENCIES_REQUEST,
		isFetching: true,
		timestamp: Date.now()
	}
}

const agenciesComplete = () => {
	return {
		type: AGENCIES_COMPLETE,
		isFetching: false,
		timestamp: Date.now()
	}
}

const agenciesFailed = (error) => {
	return {
		type: AGENCIES_FAIL,
		isFetching: false,
		error: error,
		timestamp: Date.now()
	}
}

export const fetchAgencyMunicipalities = (entity) => (dispatch) => {
	return dispatch(sessionService.loadUser)
		.then(sess => {
			const options = {
				headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json',
					'Authorization': `Bearer ${sess.profile.access_token}`
				},
				method: 'get'
			};

			dispatch(agencyMunicipalitiesRequest())
			return fetch(`${API2_URL}/municipalities?state_id=${entity}&order_by[field]=name&per_page=all`, options)
				.then(result => {
					if (result.status >= 200 && result.status < 300) {
						return result.json();
					} else {
						return result.json().then(Promise.reject.bind(Promise));
					}
				})
				.then(
					json => dispatch(agencyMunicipalitiesData(json)),
					error => {
						dispatch(newNotification({title:"¡Oh no!", content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error), type: "danger"}));
						return dispatch(agenciesFailed(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)));
					}
				)
		})
}

const agencyMunicipalitiesRequest = () => {
	return {
		type: AGENCIES_MUNICIPALITIES_REQUEST,
		isFetching: true,
		timestamp: Date.now()
	}
}

const agencyMunicipalitiesData = (json) => {
	return {
		type: AGENCIES_MUNICIPALITIES_FETCH,
		isFetching: false,
		payload: json.data,
		timestamp: Date.now()
	}
}


// WEBPACK FOOTER //
// ./src/actions/agencies.js